<!-- 文书信息详情 -->
<template>
  <div class="essay-info-detail">
    <template>
      <div class="essay-info-detail-item"
           v-for="(item, index) in billList"
           :key="index">
        <h1>文书 0{{index+1}}</h1>
        <div class="essay-info-detail-formItem">
          <h2>文书名称</h2>
          <div class="essay-info-detail-con">{{item.title}}</div>
        </div>
        <div class="essay-info-detail-formItem">
          <h2>字数限制</h2>
          <div class="essay-info-detail-con">{{item.count}}</div>
        </div>
        <div class="essay-info-detail-formItem">
          <h2>文书描述</h2>
          <div v-html="item.description"
               class='break-word-style'>{{item.description}}</div>
        </div>
        <div class="essay-info-detail-formItem"
             v-if="item.uploadStatus === 'NOTUPLOAD'">
          <Button class="zlr-btn-default"
                  @click="editHandle(item)">编辑</Button>
        </div>
      </div>
    </template>
    <div class="essay-info-fill-add"
         v-if="billList.length<2 && !projectDetail.finishBill">
      <div>
        <div class="essay-add"
             @click="addHandle">+ 添加更多 文书</div>
      </div>
      <div class="essay-info-fill-prompt"
           v-if="billList.length>=2 && !projectDetail.finishBill">
        文书篇数已达上限，请联系CD
      </div>
    </div>
    <div class="essay-info-detail-prompt"
         v-if="projectDetail.finishBill">
      已经填写该项目下所有文书
    </div>
  </div>
</template>
<script>
// api
import { getBillList } from '@/api/bill'
import { mapState } from 'vuex'
export default {
  name: 'project-essay-info-detail',
  components: {},
  data () {
    return {
      html: 'aaaa',
      programId: this.$route.params.id,
      billList: []
    }
  },
  computed: {
    ...mapState({
      projectDetail (state) {
        return state.project.projectDetail
      }
    })
  },
  mounted () {
    this.getBillList()
  },
  methods: {
    // 获取文书信息
    getBillList () {
      getBillList({
        'id': this.programId
      }).then(res => {
        this.billList = res.data.model
      })
    },
    // 添加文书
    addHandle () {
      this.$router.push({
        name: 'project-essay-info-fill'
      })
    },
    // 编辑
    editHandle ({ id }) {
      this.$router.push({
        name: 'project-essay-info-edit',
        query: {
          id
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
.break-word-style {
  word-break: break-all;
}
</style>
